import { isString } from 'lodash-es';

export function isStringOnDateString(dateOrString: Date | string): dateOrString is string {
  return isString(dateOrString);
}
